import type { ReactNode } from 'react';

import type { MultiSelectOption } from './multi-select-option';
import { MultiSelectBadge } from './multi-select-trigger-content/multi-select-badge';

type Props = {
    options: MultiSelectOption[];
    selected: string[];
    placeholder?: string;
    groupLabel?: string;
    deleteBadgeIcon: ReactNode;
    badgeClassName?: string;
    disabled?: boolean;
    onRemove: (value: string) => void;
};

export function MultiSelectTriggerContent({
    options,
    selected,
    placeholder,
    groupLabel,
    deleteBadgeIcon,
    badgeClassName,
    disabled,
    onRemove,
}: Props) {
    const optionsByValue = new Map(options.map((o) => [o.value, o]));

    return (
        <>
            {groupLabel && <p className="text-muted-foreground mb-1 text-xs">{groupLabel}</p>}

            <div className="flex flex-wrap items-center gap-1 pr-2.5">
                {selected.length > 0 ? (
                    selected.map((val) => {
                        const option = optionsByValue.get(val);
                        return option ? (
                            <MultiSelectBadge
                                key={val}
                                value={val}
                                label={option.label}
                                icon={deleteBadgeIcon}
                                onRemove={onRemove}
                                disabled={disabled}
                                className={badgeClassName}
                            />
                        ) : null;
                    })
                ) : (
                    <span className="text-muted-foreground h-5 inline-block">{placeholder}</span>
                )}
            </div>
        </>
    );
}
